// extracted by mini-css-extract-plugin
export default {"highlightingImage":"highlightingImage__sQoP7J","advancedSettings":"advancedSettings__zVabNB","formatAlert":"formatAlert__O2pxS1","documentationLink":"documentationLink__xlkIx8"};